import React, {useEffect, useState} from "react";
import {Box, Tab, Tabs, Typography} from "@material-ui/core";
import {useTheme} from "@material-ui/core/styles";
import {useTranslation} from "react-i18next";
import _ from "lodash";
import CustomTimeCard from "../../../components/custom-time-card/custom-card-card";

interface TabPanelProps {
    children?: React.ReactNode;
    dir?: string;
    index: any;
    value: any;
}

const TabPanel = (props: TabPanelProps) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

const a11yProps = (index: any) => {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}
interface OputputSettingsTimerMode {
    timeSettings: object,
    tmpTime: object,
    onChange: (data: number) => void,
    onChangeChips: (data: any) => void
}

export const OutputSettingsTimerMode: React.FC<OputputSettingsTimerMode> = (props) => {
    const theme = useTheme();
    const [value, setValue] = React.useState(1);
    const [mainChips, setMainChips] = useState({});
    const {t} = useTranslation();
    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setValue(newValue);
        props.onChange(newValue);
    };

    useEffect(() => {
        console.log('on change');
        setMainChips(props.timeSettings);
        const firstDay = _.get(props.timeSettings, '0', null);
        const saturday = _.get(props.timeSettings, '5', null);
        if (!firstDay || !saturday) {
            setValue(1);
            props.onChange(1);
        } else {
            let v = 0;
            for(let i = 1; i < 5; i++) {
                if (!_.isEqual(firstDay, _.get(props.timeSettings, i.toString(), null))) {
                    v = 1;
                }

            }
            if (!_.isEqual(saturday, _.get(props.timeSettings, 6, null))) {
                v = 1;
            }
            setValue(v);
            props.onChange(v);
        }

    }, [props.timeSettings]);

    const createDaysObject = (chips: any, day: number) => {
        return {
            [day]: chips
        }
    }
    const handleChangeChips = (chips: any, days: number[]) => {
        const tmp = _.assign({}, mainChips);
        days.forEach((day) => _.assign(tmp, createDaysObject(chips, day)));
        setMainChips(tmp);
        props.onChangeChips(tmp);
    }
    return (
        <div>
            <Tabs
                value={value}
                indicatorColor="primary"
                textColor="primary"
                onChange={handleChange}
            >
                {/*<Tab label={t('timeMode.sameDay')} {...a11yProps(0)} />*/}
                <Tab label={t('timeMode.weekends')} {...a11yProps(0)} />
                <Tab label={t('timeMode.everyday')} {...a11yProps(1)} />
            </Tabs>
            <div className='card default-card'>
                <div className="card-body">
                    {/*<TabPanel value={value} index={0} dir={theme.direction}>*/}
                    {/*    <CustomTimeCard*/}
                    {/*        title={t('timecard.everyDay.title')}*/}
                    {/*        dayNumber={0}*/}
                    {/*        description={t('timecard.description')}*/}
                    {/*        onChange={(chip) => handleChangeChips(chip, [0, 1, 2, 3, 4, 5, 6])}*/}
                    {/*        dayRanges={_.get(mainChips, '0', [])} tmpTime={props.tmpTime} />*/}
                    {/*</TabPanel>*/}
                    <TabPanel value={value} index={0} dir={theme.direction}>
                        <CustomTimeCard
                            onChange={(chip) => handleChangeChips(chip, [0, 1, 2, 3, 4])}
                            tmpTime={props.tmpTime} title={t('timecard.weekday.title.week')} dayNumber={0} description={t('timecard.description')} dayRanges={_.get(mainChips, '0', [])} />
                        <CustomTimeCard
                            onChange={(chip) => handleChangeChips(chip, [5, 6])}
                            tmpTime={props.tmpTime} title={t('timecard.weekend.title.weekend')} dayNumber={5} description={t('timecard.description')} dayRanges={_.get(mainChips, '5', [])} />
                    </TabPanel>
                    <TabPanel value={value} index={1} dir={theme.direction}>
                        {
                            [0, 1, 2, 3, 4, 5, 6].map((weekDay) => <CustomTimeCard onChange={(chip) => handleChangeChips(chip, [weekDay])}
                                                                                   tmpTime={props.tmpTime} dayNumber={weekDay} title={t('timecard.day.' + weekDay + '.title')} description={t('timecard.description')} dayRanges={_.get(mainChips, weekDay, [])} />)
                        }
                    </TabPanel>
                </div>
            </div>

        </div>
    )
}